// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";

import {
  SET_GOODDEALS_TITLE_EN,
  SET_GOODDEALS_PROMOTION_EN,
  SET_GOODDEALS_DESCRIPTION_EN,
  SET_GOODDEALS_OPENING_TIME_EN,
  SET_GOODDEALS_PRICE_EN,
  SELECT_GOODDEALS_ACTIVITY_CHOICE_EN,
  SET_GOODDEALS_ACTIVITY_NAME_EN,
  SET_GOODDEALS_ACTIVITY_DESCRIPTION_EN,
  SET_GOODDEALS_ACTIVITY_POST_DESCRIPTION_EN
} from "actions/types";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

// core components
import CustomInput from "components/CustomInput/CustomInput";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputAdornment: {
    position: "relative"
  },
  ...customInputStyle,
  ...customSelectStyle,
  ...regularFormsStyle
};

class Step3 extends React.Component {
  sendState() {
    return this.state;
  }

  isValidated() {
    return true;
  }

  renderMenuItems = choices => {
    const { classes } = this.props;
    const components = [];

    // eslint-disable-next-line
    for (const obj of Object.values(choices)) {
      components.push(
        <MenuItem
          key={obj.name}
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected
          }}
          value={obj.name}
        >
          {obj.name}
        </MenuItem>
      );
    }
    return components;
  };

  render() {
    const {
      dispatch,
      classes,
      lang,
      templateId,
      activityNameEn,
      activityDescriptionEn,
      activityPostDescriptionEn,
      choices,
      choiceId
    } = this.props;
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <CustomInput
            labelText="Titre"
            id="title-en"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              value: lang && lang.en && lang.en.title ? lang.en.title : "",
              onChange: e =>
                dispatch({
                  type: SET_GOODDEALS_TITLE_EN,
                  value: e.target.value
                })
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <CustomInput
            labelText="Description"
            id="descrption-en"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              value:
                lang && lang.en && lang.en.description
                  ? lang.en.description
                  : "",
              onChange: e =>
                dispatch({
                  type: SET_GOODDEALS_DESCRIPTION_EN,
                  value: e.target.value
                }),
              multiline: true,
              rows: 5
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <CustomInput
            labelText="Prix"
            id="price-en"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              value: lang && lang.en && lang.en.price ? lang.en.price : "",
              onChange: e =>
                dispatch({
                  type: SET_GOODDEALS_PRICE_EN,
                  value: e.target.value
                }),
              multiline: true,
              rows: 3
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <CustomInput
            labelText="Promotion"
            id="promotion-en"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              value:
                lang && lang.en && lang.en.promotion ? lang.en.promotion : "",
              onChange: e =>
                dispatch({
                  type: SET_GOODDEALS_PROMOTION_EN,
                  value: e.target.value
                })
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <CustomInput
            labelText="Période d'ouverture / Horaires"
            id="opening-time-en"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              value:
                lang && lang.en && lang.en.openingTime
                  ? lang.en.openingTime
                  : "",
              onChange: e =>
                dispatch({
                  type: SET_GOODDEALS_OPENING_TIME_EN,
                  value: e.target.value
                }),
              multiline: true,
              rows: 3
            }}
          />
        </GridItem>
        {templateId && (
          <Fragment>
            <legend>Choix pour la recherche de partenaire</legend>
            {choices && (
              <GridItem xs={12} sm={12} md={12}>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <InputLabel
                    htmlFor="simple-select"
                    className={classes.selectLabel}
                  >
                    Sélectionner le choix à mettre à jour
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    classes={{
                      select: classes.select
                    }}
                    value={choiceId ? choiceId : ""}
                    onChange={e =>
                      dispatch({
                        type: SELECT_GOODDEALS_ACTIVITY_CHOICE_EN,
                        payload: e.target.value
                      })
                    }
                    inputProps={{
                      required: true,
                      name: "simpleSelect",
                      id: "simple-select"
                    }}
                  >
                    <MenuItem
                      disabled
                      classes={{
                        root: classes.selectMenuItem
                      }}
                    >
                      Choix
                    </MenuItem>
                    {this.renderMenuItems(choices)}
                  </Select>
                </FormControl>
              </GridItem>
            )}
            {choices && (
              <GridItem xs={12} sm={12} md={12}>
                <CustomInput
                  labelText="Nom"
                  id="set-name-en"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    required: true,
                    value: activityNameEn ? activityNameEn : "",
                    onChange: e =>
                      dispatch({
                        type: SET_GOODDEALS_ACTIVITY_NAME_EN,
                        payload: e.target.value
                      })
                  }}
                />
              </GridItem>
            )}
            <GridItem xs={12} sm={12} md={12}>
              <CustomInput
                labelText="Description"
                id="description-en"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: activityDescriptionEn ? activityDescriptionEn : "",
                  required: true,
                  onChange: e =>
                    dispatch({
                      type: SET_GOODDEALS_ACTIVITY_DESCRIPTION_EN,
                      payload: e.target.value
                    }),
                  multiline: true,
                  rows: 5
                }}
              />
              <CustomInput
                labelText="Description après photo"
                id="post-description-en"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: activityPostDescriptionEn
                    ? activityPostDescriptionEn
                    : "",
                  onChange: e =>
                    dispatch({
                      type: SET_GOODDEALS_ACTIVITY_POST_DESCRIPTION_EN,
                      payload: e.target.value
                    }),
                  multiline: true,
                  rows: 3
                }}
              />
            </GridItem>
          </Fragment>
        )}
      </GridContainer>
    );
  }
}

Step3.propTypes = {
  classes: PropTypes.object
};

const mapStateToProps = state => {
  const {
    lang,
    templateId,
    activityNameEn,
    activityDescriptionEn,
    activityPostDescriptionEn,
    choices,
    choiceId
  } = state.gooddealReducer;
  return {
    lang,
    templateId,
    activityNameEn,
    activityDescriptionEn,
    activityPostDescriptionEn,
    choices,
    choiceId
  };
};

export default connect(mapStateToProps)(withStyles(style)(Step3));
